import { render, staticRenderFns } from "./workspace-column.vue?vue&type=template&id=1acd21ac&scoped=true&"
import script from "./workspace-column.vue?vue&type=script&lang=js&"
export * from "./workspace-column.vue?vue&type=script&lang=js&"
import style0 from "./workspace-column.vue?vue&type=style&index=0&id=1acd21ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd21ac",
  null
  
)

export default component.exports